import {
    Box,
    Button, CircularProgress, Dialog,
    Divider,
    FormControlLabel,
    FormGroup,
    Grid, InputLabel, MenuItem, Select,
    styled,
    TextField,
    Typography, useMediaQuery,
    useTheme
} from "@mui/material";
import { useContext,  useState} from "react";
import BuySharesContext from "../../store/buy-shares-context";
import CustomCheckbox from "./CustomCheckbox";
import SnackbarContext from "../../store/snackbar-context";
import panda from "../../assets/images/panda.svg";
import isEmail from "validator/lib/isEmail";
import isMobilePhone from "validator/lib/isMobilePhone";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import StakeHolderForm from "./StakeholderForm";
import FormInfoBanner from "./FormInfoBanner";
import {sendData, sendForm} from "../../api/contact-api";

const countries = ["Afganistan", "Albania", "Algieria", "Andora", "Angola", "Antigua i Barbuda", "Arabia Saudyjska", "Argentyna", "Armenia", "Australia", "Austria", "Azerbejdżan", "Bahamy", "Bahrajn", "Bangladesz", "Barbados", "Belgia", "Belize", "Benin", "Bhutan", "Białoruś", "Boliwia", "Bośnia i Hercegowina", "Botswana", "Brazylia", "Brunei", "Bułgaria", "Burkina Faso", "Burundi", "Chile", "Chiny", "Chorwacja", "Cypr", "Czad", "Czarnogóra", "Czechy", "Dania", "Demokratyczna Republika Konga", "Dominika", "Dominikana", "Dżibuti", "Egipt", "Ekwador", "Erytrea", "Estonia", "Etiopia", "Fidżi", "Filipiny", "Finlandia", "Francja", "Gabon", "Gambia", "Ghana", "Grecja", "Grenada", "Gruzja", "Gujana", "Gwatemala", "Gwinea", "Gwinea Bissau", "Gwinea Równikowa", "Haiti", "Hiszpania", "Holandia", "Honduras", "Indie", "Indonezja", "Irak", "Iran", "Irlandia", "Islandia", "Jamajka", "Japonia", "Jemen", "Jordania", "Kambodża", "Kamerun", "Kanada", "Katar", "Kazachstan", "Kenia", "Kirgistan", "Kiribati", "Kolumbia", "Komory", "Kongo", "Korea Południowa", "Korea Północna", "Kostaryka", "Kuba", "Kuwejt", "Laos", "Lesotho", "Liban", "Liberia", "Libia", "Liechtenstein", "Litwa", "Luksemburg", "Łotwa", "Macedonia", "Madagaskar", "Malawi", "Malediwy", "Malezja", "Mali", "Malta", "Maroko", "Mauretania", "Mauritius", "Meksyk", "Mikronezja", "Mjanma", "Mołdawia", "Monako", "Mongolia", "Mozambik", "Namibia", "Nauru", "Nepal", "Niemcy", "Niger", "Nigeria", "Nikaragua", "Norwegia", "Nowa Zelandia", "Oman", "Pakistan", "Palau", "Panama", "Papua-Nowa Gwinea", "Paragwaj", "Peru", "Polska", "Portugalia", "Południowa Afryka", "Republika Środkowoafrykańska", "Republika Zielonego Przylądka", "Rosja", "Rumunia", "Rwanda", "Saint Kitts i Nevis", "Saint Lucia", "Saint Vincent i Grenadyny", "Salwador", "Samoa", "San Marino", "Senegal", "Serbia", "Seszele", "Sierra Leone", "Singapur", "Słowacja", "Słowenia", "Somalia", "Sri Lanka", "Suazi", "Sudan", "Sudan Południowy", "Surinam", "Syria", "Szwajcaria", "Szwecja", "Tadżykistan", "Tajlandia", "Tanzania", "Timor Wschodni", "Togo", "Tonga", "Trynidad i Tobago", "Tunezja", "Turcja", "Turkmenistan", "Tuvalu", "Uganda", "Ukraina", "Urugwaj", "Uzbekistan", "Vanuatu", "Watykan", "Wenezuela", "Węgry", "Wielka Brytania", "Wietnam", "Włochy", "Wybrzeże Kości Słoniowej", "Wyspy Marshalla", "Wyspy Salomona", "Wyspy Świętego Tomasza i Książęca", "Zambia", "Zimbabwe", "Zjednoczone Emiraty Arabskie"]

const StyledField = styled(TextField)({
    width: "100%",

    '& .MuiInputBase-input': {
        backgroundColor: "white",
        border: "none",
        borderRadius: 0,
        minHeight: "40px",
        fontSize: "26px",
        fontWeight: 600,
    },

    '& .Mui-error': {
            border: "1px solid red",
    },

    '& .MuiOutlinedInput-root': {

        '& fieldset': {
            border: "none",
            borderRadius: 0,
        },
        '&:hover fieldset': {
            border: "none",
            borderRadius: 0,
        },
        '&.Mui-focused fieldset': {
            border: "none",
            borderRadius: 0,
        },
    },
})

const StyledSelect = styled(Select)({
    width: "100%",

    '& .MuiInputBase-input': {
        backgroundColor: "white",
        border: "none !important",
        borderRadius: 0,
        minHeight: "40px",
        fontSize: "26px",
        fontWeight: 600,
        paddingTop: "22px",
        paddingBottom: "7px",
    },

    '& .MuiOutlinedInput-notchedOutline': {
        border: "none",
        borderRadius: 0,
        paddingBottom: 0,

        '& fieldset': {
            border: "none",
            borderRadius: 0,
        },
        '&:hover fieldset': {
            border: "none",
            borderRadius: 0,
        },
        '&.Mui-focused fieldset': {
            border: "none",
            borderRadius: 0,
        },
    },
})

const StyledLabel = styled(InputLabel)({
    fontWeight: 600,
    color: "black",
    paddingBottom: "23px",
    fontFamily: "Montserrat",
    fontSize: "20px !important",
    whiteSpace: "normal",
    height: "auto",
})

const StyledNote = styled(InputLabel)({
    fontWeight: 600,
    color: "gray",
    fontFamily: "Montserrat",
    fontSize: "16px !important",
    whiteSpace: "normal",
    height: "auto",
})

const errorsState = {
    agreements: "Zaznacz wymagane zgody",
    companyName: "Nazwa firmy musi zawierać więcej niż 2 znaki",
    firstName: "Pole imię musi zawierać więcej niż 2 znaki",
    lastName: "Pole nazwisko musi zawierać więcej niż 2 znaki",
    email: "Pole email musi zawierać poprawny adres email",
    phone: "Pole telefon musi zawierać poprawny numer telefonu",
    nip: "Pole NIP musi zawierać poprawny numer",
    regon: "Pole REGON musi zawierać poprawny numer",
    country: "Wybierz kraj",
    street: "Pole ulica musi zawierać więcej niż 2 znaki",
    buildingNumber: "Pole Nr domu musi być wypełnione",
    apartmentNumber: "",
    postalCode: "Pole kod pocztowy musi zawierać poprawny kod pocztowy",
    city: "Pole miasto musi zawierać conajmniej 3 znaki",
    idNumber: "Pole nr dowodu musi zawierać poprawny numer",
    pesel: "Pole pesel musi zawierać poprawny numer"
}

const FourthStep = () => {
    const {palette, breakpoints} = useTheme();
    const isSmall = useMediaQuery(breakpoints.down('md'));
    const [openModal, setOpenModal] = useState(false);
    const ctx = useContext(BuySharesContext);
    const {setMsg} = useContext(SnackbarContext);
    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState(errorsState);
    const [agreement, setAgreement] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [sendSuccess, setSendSuccess] = useState(false);

    const handleGoNext = () => {
        setValidated(true);
        if (validateForm()) {
            saveData();
        }
    }

    const handleCompanyNameChange = (value: string) => {
        if(!ctx.isCompany) {
            return;
        }
        ctx.setCompanyName(value);
        if(value.length <2) {
            setErrors({...errors, companyName: errorsState.companyName})
        } else {
            setErrors({...errors, companyName: ""})
        }
    }

    const handleFirstNameChange = (value: string) => {
        if(ctx.isCompany) {
            return;
        }
        ctx.setFirstName(value);
        if(value.length <2) {
            setErrors({...errors, firstName: errorsState.firstName})
        } else {
            setErrors({...errors, firstName: ""})
        }
    }

    const handleLastNameChange = (value: string) => {
        if(ctx.isCompany) {
            return;
        }
        ctx.setLastName(value);
        if(value.length <2) {
            setErrors({...errors, lastName: errorsState.lastName})
        } else {
            setErrors({...errors, lastName: ""})
        }
    }

    const handleEmailChange = (value: string) => {
        ctx.setEmail(value);
        if(!isEmail(value)) {
            setErrors({...errors, email: errorsState.email})
        } else {
            setErrors({...errors, email: ""})
        }
    }

    const handlePhoneChange = (value: string) => {
        ctx.setPhone(value);
        if(!isMobilePhone(value, 'pl-PL')) {
            setErrors({...errors, phone: errorsState.phone})
        } else {
            setErrors({...errors, phone: ""})
        }
    }

    const handleIdNumberChange = (value: string) => {
        if(ctx.isCompany) {
            return;
        }
        ctx.setIdNumber(value);
        if(value.length <2) {
            setErrors({...errors, idNumber: errorsState.idNumber})
        } else {
            setErrors({...errors, idNumber: ""})
        }
    }

    const handlePeselChange = (value: string) => {
        if(ctx.isCompany) {
           return;
        }
        ctx.setPesel(value);
        const reg = new RegExp("^[0-9]{11}$")
        if(!reg.test(value)) {
            setErrors({...errors, pesel: errorsState.pesel})
        } else {
            setErrors({...errors, pesel: ""})
        }
    }

    const handleNipChange = (value: string) => {
        if(!ctx.isCompany) {
            return;
        }
        ctx.setNip(value);
        const reg = new RegExp("^[0-9]{10}$")
        if(!reg.test(value)) {
            setErrors({...errors, nip: errorsState.nip})
        } else {
            setErrors({...errors, nip: ""})
        }
    }

    const handleRegonChange = (value: string) => {
        if(!ctx.isCompany) {
            return;
        }
        ctx.setRegon(value);
        const reg = new RegExp("^[0-9]{9}$")
        if(!reg.test(value)) {
            setErrors({...errors, regon: errorsState.regon})
        } else {
            setErrors({...errors, regon: ""})
        }
    }

    const handleCountryChange = (value: any) => {
        if(value) {
            ctx.setCountry(value);
            setErrors({...errors, country: ""})
        }
    }

    const handleStreetChange = (value: string) => {
        ctx.setStreet(value);
        if(value.length <2) {
            setErrors({...errors, street: errorsState.street})
        } else {
            setErrors({...errors, street: ""})
        }
    }

    const handleBuildingNumberChange = (value: string) => {
        ctx.setBuildingNumber(value);
        if(value.length < 1) {
            setErrors({...errors, buildingNumber: errorsState.buildingNumber})
        } else {
            setErrors({...errors, buildingNumber: ""})
        }
    }

    const handleApartmentNumberChange = (value: string) => {
        ctx.setApartmentNumber(value);
        if(value.length < 1) {
            setErrors({...errors, apartmentNumber: errorsState.apartmentNumber})
        } else {
            setErrors({...errors, apartmentNumber: ""})
        }
    }

    const handlePostalCodeChange = (value: string) => {
        ctx.setPostalCode(value);
        const reg = new RegExp("^[0-9]{2}-[0-9]{3}$")
        if(!reg.test(value)) {
            setErrors({...errors, postalCode: errorsState.postalCode})
        } else {
            setErrors({...errors, postalCode: ""})
        }
    }

    const handleCityChange = (value: string) => {
        ctx.setCity(value);
        if(value.length < 3) {
            setErrors({...errors, city: errorsState.city})
        } else {
            setErrors({...errors, city: ""})
        }
    }

    const handleAgreementChange = (value: boolean) => {
        setAgreement(value)
        if(value) {
            setErrors({...errors, agreements: ""})
        } else {
            setErrors({...errors, agreements: errorsState.agreements})
        }
    }

    const saveData = () => {
        if(isSending || sendSuccess) {
            return;
        }
        if (!ctx.hasData()) {
            setMsg({msg: "Uzupełnij formularz", severity: "warning"})
            return;
        }

        setIsSending(true);
        sendData(ctx,  (error) => {
            setMsg({msg: "Błąd przy zapisywaniu danych."})
        })
            .then(r => {
                setOpenModal(true);
                ctx.setLockData(true);
                ctx.setStep(4);
                setSendSuccess(true)})
            .catch((error) => {
                setMsg({msg: "Błąd przy zapisywaniu danych."})
                console.log(error);
            })
            .finally(() => setIsSending(false));
    }

    const validateForm = () => {
        if(errors.agreements !== "") {
            setMsg({msg: errors.agreements, severity: "warning"})
            return false;
        }
        if(errors.email !== "") {
            setMsg({msg: errors.email, severity: "warning"})
            return false;
        }
        if(errors.phone !== "") {
            setMsg({msg: errors.phone, severity: "warning"})
            return false;
        }
        if(errors.country !== "") {
            setMsg({msg: errors.country, severity: "warning"})
            return false;
        }
        if(errors.street !== "") {
            setMsg({msg: errors.street, severity: "warning"})
            return false;
        }
        if(errors.postalCode !== "") {
            setMsg({msg: errors.postalCode, severity: "warning"})
            return false;
        }
        if(errors.city !== "") {
            setMsg({msg: errors.city, severity: "warning"})
            return false;
        }
        if(errors.buildingNumber !== "") {
            setMsg({msg: errors.buildingNumber, severity: "warning"})
            return false;
        }
        // if(errors.apartmentNumber !== "") {
        //     setMsg({msg: errors.apartmentNumber, severity: "warning"})
        //     return false;
        // }
        if(ctx.isCompany) {
            if(errors.companyName !== "") {
                setMsg({msg: errors.companyName, severity: "warning"})
                return false;
            }
            if(errors.nip !== "") {
                setMsg({msg: errors.nip, severity: "warning"})
                return false;
            }
            if(errors.regon !== "") {
                setMsg({msg: errors.regon, severity: "warning"})
                return false;
            }
        } else {
            if(errors.firstName !== "") {
                setMsg({msg: errors.firstName, severity: "warning"})
                return false;
            }
            if(errors.lastName !== "") {
                setMsg({msg: errors.lastName, severity: "warning"})
                return false;
            }
            if(errors.idNumber !== "") {
                setMsg({msg: errors.idNumber, severity: "warning"})
                return false;
            }
            if(errors.pesel !== "") {
                setMsg({msg: errors.pesel, severity: "warning"})
                return false;
            }
        }
        return true;
    }

    return <Grid item container id="fourth-step" sx={{
        backgroundColor: palette.primary.light,
        width: "100%",
        mt: "106px",
        position: 'relative',
    }}>
        <Box component="img" src={panda} sx={{position: 'absolute', top: '0', right: '5%', width: {xs:"200px", lg: "425px"}}}/>
        <Grid item container flexDirection={"column"} sx={{
            maxWidth: '1450px',
            padding: '0 50px',
            margin: '0 auto',
            position: 'relative',
        }}>
            <Grid item mt={"87px"} mb={"35px"}>
                <Typography variant={"h3"} display={"inline"}>Wypełnij formularz zapisu na akcje</Typography>
                <Typography variant={"h3"} display={"inline"} sx={{fontWeight: 400}}> i kliknij </Typography>
                <Typography variant={"h3"} display={"inline"}>"Zainwestuj"</Typography>
            </Grid>
            <Divider sx={{backgroundColor: palette.primary.dark, maxWidth: "1020px"}}/>
            <Grid item mt={"98px"} mb={"61px"}>
                <Typography variant={"h3"}
                            sx={{textDecoration: "underline"}}>{ctx.isCompany ? "Firma:" : "Osoba fizyczna:"}</Typography>
            </Grid>
            {ctx.isCompany &&
                <Grid item container justifyContent={"space-between"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                    <Grid item sx={{width: "100%"}}>
                        <StyledLabel htmlFor={"company-name"}>Nazwa:</StyledLabel>
                        <StyledField id={"company-name"} value={ctx.companyName} error={validated && (errors.companyName !== "")} onChange={({target:{value}}) => handleCompanyNameChange(value)}/>
                    </Grid>
                </Grid>
            }
            {!ctx.isCompany &&
                <Grid item container justifyContent={"space-between"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                    <Grid item sx={{width: "100%"}}>
                        <StyledLabel htmlFor={"first-name"}>Imię:</StyledLabel>
                        <StyledField id={"first-name"} value={ctx.firstName} error={validated && (errors.firstName !== "")} onChange={({target:{value}}) => handleFirstNameChange(value)}/>
                    </Grid>
                    <Grid item sx={{width: "100%"}} ml={isSmall ? 0 : "70px"}  mt={isSmall ? "35px" : 0} >
                        <StyledLabel htmlFor={"last-name"}>Nazwisko:</StyledLabel>
                        <StyledField id={"last-name"}  value={ctx.lastName} error={validated && (errors.lastName !== "")} onChange={({target:{value}}) => handleLastNameChange(value)}/>
                    </Grid>
                </Grid>
            }
            <Grid item container justifyContent={"space-between"} mt={"35px"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                <Grid item sx={{width: "100%"}}>
                    <StyledLabel htmlFor={"email"}>E-mail:</StyledLabel>
                    <StyledField id={"email"} value={ctx.email} error={validated && (errors.email !== "")} onChange={({target:{value}}) => handleEmailChange(value)}/>
                </Grid>
                <Grid item sx={{width: "100%"}} ml={isSmall ? 0 : "70px"}  mt={isSmall ? "35px" : 0} >
                    <StyledLabel htmlFor={"phone"}>Telefon:</StyledLabel>
                    <StyledField id={"phone"} value={ctx.phone} error={validated && (errors.phone !== "")} onChange={({target:{value}}) => handlePhoneChange(value)}/>
                </Grid>
            </Grid>
            {ctx.isCompany &&
                <Grid item container justifyContent={"space-between"} mt={"35px"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                    <Grid item sx={{width: "100%"}}>
                        <StyledLabel htmlFor={"id-number"}>NIP:</StyledLabel>
                        <StyledField id={"id-number"} value={ctx.nip} error={validated && (errors.nip !== "")} onChange={({target:{value}}) => handleNipChange(value)}/>
                    </Grid>
                    <Grid item sx={{width: "100%"}} ml={isSmall ? 0 : "70px"}  mt={isSmall ? "35px" : 0} >
                        <StyledLabel htmlFor={"pesel"}>REGON:</StyledLabel>
                        <StyledField id={"pesel"} value={ctx.regon} error={validated && (errors.regon !== "")} onChange={({target:{value}}) => handleRegonChange(value)}/>
                    </Grid>
                </Grid>
            }
            {!ctx.isCompany &&
                <Grid item container justifyContent={"space-between"} mt={"35px"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                    <Grid item sx={{width: "100%"}}>
                        <StyledLabel htmlFor={"id-number"}>Nr dowodu:</StyledLabel>
                        <StyledField id={"id-number"} value={ctx.idNumber} error={validated && (errors.idNumber !== "")}  onChange={({target:{value}}) => handleIdNumberChange(value)}/>
                    </Grid>
                    <Grid item sx={{width: "100%"}} ml={isSmall ? 0 : "70px"}  mt={isSmall ? "35px" : 0} >
                        <StyledLabel htmlFor={"pesel"}>PESEL:</StyledLabel>
                        <StyledField id={"pesel"} value={ctx.pesel} error={validated && (errors.pesel !== "")} onChange={({target:{value}}) => handlePeselChange(value)}/>
                    </Grid>
                </Grid>
            }
            <Grid item container justifyContent={"space-between"} mt={"35px"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                <Grid item sx={{width: "100%"}}>
                    <StyledLabel htmlFor={"country"}>Kraj:</StyledLabel>
                    <StyledSelect
                        id="country"
                        value={ctx.country}
                        error={validated && (errors.country !== "")}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: (validated && (errors.country !== "")) ? "1px solid red" : "none",
                                borderRadius: 0,
                                paddingBottom: 0,
                            }
                        }}
                        onChange={({target:{value}}) => handleCountryChange(value)}
                    >
                        {countries.map(country => (
                            <MenuItem value={country}>{country}</MenuItem>
                        ))}
                    </StyledSelect>
                    <StyledNote htmlFor={"id-number"}>* Z uwagi na tzw. ustawę FATCA (Foreign Account Tax Compliance
                        Act) Emitent nie oferuje akcji rezydentom podatkowym USA.</StyledNote>
                </Grid>
                <Grid item sx={{width: "100%"}} ml={isSmall ? 0 : "70px"}  mt={isSmall ? "35px" : 0} >
                    <StyledLabel htmlFor={"street"}>Ulica:</StyledLabel>
                    <StyledField id={"street"} value={ctx.street} error={validated && (errors.street !== "")} onChange={({target:{value}}) => handleStreetChange(value)}/>
                </Grid>
            </Grid>
            <Grid item container justifyContent={"space-between"} mt={"35px"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                <Grid item sx={{width: "100%"}}>
                    <StyledLabel htmlFor={"id-number"}>Nr domu:</StyledLabel>
                    <StyledField id={"id-number"} value={ctx.buildingNumber} error={validated && (errors.buildingNumber !== "")} onChange={({target:{value}}) => handleBuildingNumberChange(value)}/>
                </Grid>
                <Grid item sx={{width: "100%"}} ml={isSmall ? 0 : "70px"}  mt={isSmall ? "35px" : 0} >
                    <StyledLabel htmlFor={"pesel"}>Nr mieszkania:</StyledLabel>
                    <StyledField id={"pesel"} value={ctx.apartmentNumber} error={validated && (errors.apartmentNumber !== "")} onChange={({target:{value}}) => handleApartmentNumberChange(value)}/>
                </Grid>
            </Grid>
            <Grid item container justifyContent={"space-between"} mt={"35px"} sx={{width: {xs: "100%", lg: "80%"}}} wrap={isSmall ? "wrap" : "nowrap"}>
                <Grid item sx={{width: "100%"}}>
                    <StyledLabel htmlFor={"postal-code"}>Kod pocztowy:</StyledLabel>
                    <StyledField id={"postal-code"} value={ctx.postalCode} error={validated && (errors.postalCode !== "")} onChange={({target:{value}}) => handlePostalCodeChange(value)}/>
                </Grid>
                <Grid item sx={{width: "100%"}} ml={isSmall ? 0 : "70px"}  mt={isSmall ? "35px" : 0} >
                    <StyledLabel htmlFor={"city"}>Miasto:</StyledLabel>
                    <StyledField id={"city"} value={ctx.city} error={validated && (errors.city !== "")} onChange={({target:{value}}) => handleCityChange(value)}/>
                </Grid>
            </Grid>
            <Typography variant={"h3"} mb={"35px"} mt={"63px"}>Zaznacz zgodę na przetwarzanie danych osobowych</Typography>
            <Divider sx={{backgroundColor: palette.primary.dark, maxWidth: "1020px"}}/>
            <FormGroup sx={{flexDirection: "row", mt: "40px", mb: "78px"}}>
                <FormControlLabel control={<CustomCheckbox isError={validated && (errors.agreements !== "")} checkboxProps={{
                    checked: agreement,
                    onChange: () => handleAgreementChange(true)
                }}/>}
                                  label={"(…) Potwierdzam, iż zapoznałem się z Informacją o przetwarzaniu danych osobowych przez spółkę Browar Za Miastem sp. z o.o. SKA oraz przyjąłem/przyjęłam do wiadomości, że w związku z realizacją procesu zapisu na akcje, spółka Browar Za Miastem sp. z o.o. SKA może kontaktować się ze mną za pośrednictwem telefonu lub komunikacji e-mail."} sx={{
                    "& span": {
                        color: "black",
                        fontWeight: 400,
                        fontFamily: "Montserrat",
                        fontSize: "20px"
                    }}}/>
            </FormGroup>
            <Button sx={{
                maxWidth: '400px',
                m: "60px 0 64px 0",
                textAlign: 'center',
                height: "100px",
                fontSize: '30px',
                fontWeight: 600,
                backgroundColor: palette.secondary.light,
                borderRadius: 0
            }} variant='contained' onClick={() => handleGoNext()}>
                {isSending ? <CircularProgress color={"secondary"}/> :
                <Grid item container flexDirection={"column"} alignItems={"center"}>
                    Zainwestuj
                    <Typography variant={"subtitle2"}>i pobierz formularz zapisu na akcje</Typography>
                </Grid>}
            </Button>
        </Grid>
        <Dialog open={openModal} maxWidth={"lg"} onClose={() => setOpenModal(false)}>
            <StakeHolderForm close={() => {}}/>
            <Button variant="contained" size={"large"} onClick={() => setOpenModal(false)} startIcon={<ArrowBackIosNewIcon/>}
                    sx={{backgroundColor: palette.secondary.light, marginRight: "15mm", marginLeft: "15mm", marginBottom: "15mm"}}>Wróć</Button>
        </Dialog>
        {openModal && <FormInfoBanner/>}
    </Grid>
}

export default FourthStep;